export default function removeLegacyProject(state, action) {
  const { uniqueKey } = action
  const { legacyProjects } = state
  return {
    ...state,
    legacyProjects: legacyProjects.filter(p => p.uniqueKey !== uniqueKey)
  }
}



// WEBPACK FOOTER //
// ./src/reducers/removeLegacyProject.js